export { EventEmitter } from 'node:events';
